import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.min.css";
import "./index.css";
import axios from "axios";
import { TonConnectUIProvider ,THEME} from '@tonconnect/ui-react';
import TelegramAnalytics from '@telegram-apps/analytics'
import "./common/utils/envSanityCheck";
import "./common/utils/logPaymentError";

axios.defaults.baseURL = process.env.REACT_APP_API;

// @ts-ignore
window.changeLanguage = (lang: string) => {
  const langDetector = document.getElementById("lang-detector");
  if (langDetector) {
    (langDetector as HTMLInputElement).value = lang;
    langDetector?.dispatchEvent(new CustomEvent("change"));
  }
};

// if (window.Telegram?.WebApp) {
//   TelegramAnalytics.init({
//     token: "eyJhcHBfbmFtZSI6InZvdGVfdG9fZWFybiIsImFwcF91cmwiOiJodHRwczovL3QubWUvVm90ZVRvRWFybkJvdCIsImFwcF9kb21haW4iOiJodHRwczovL2FwcC52b3RldG9lYXJuLm5ldC8ifQ==!RvcklbmMC0H4rxzUga6SKAGtuyxCToSvtrnunx63DDw=",
//     appName: 'vote_to_earn',
//   });
// } else {
//   console.warn('Not running inside Telegram WebApp — skipping TelegramAnalytics.init');
// }



const root = ReactDOM.createRoot(
  document.getElementById('app') as HTMLElement
);
root.render(
<React.StrictMode>
<TonConnectUIProvider
          manifestUrl="https://app.votetoearn.net/tonconnect-manifest.json"          
          uiPreferences={{ theme: THEME.DARK }}              
      >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </TonConnectUIProvider>
  </React.StrictMode>,
)


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// registerServiceWorker();

const sw = "../firebase-messaging-sw.js";
// process.env.NODE_ENV === "production"
//   ? `${process.env.REACT_APP_SITE_URL}wp-content/plugins/coin-parliament/public/firebase-messaging-sw.js`
//   : "../firebase-messaging-sw.js";
// console.log(sw)
if ("serviceWorker" in navigator) {
  navigator?.serviceWorker
    .register(sw)
    .then(function (registration) {
      console.log("Registration successful, scope is:", registration.scope);
    })
    .catch(function (err) {
      console.log("Service worker registration failed, error:", err);
    });
}
